export enum SignInMode {
  Standard = "standard",
  MobileConfirm = "mobileConfirm",
  MobileOtp = "mobileOtp",
  UpdateDetails = "updateDetails",
  OtpVerification = "otpVerification"
}
export type TabKey = "password" | "emailOtp";
